class categoryHeaderBannersController {
    constructor(bannersService) {
        this.bannersService = bannersService;
    }

    $onChanges() {
        this.getBanners();
    }

    getBanners() {
        this.bannersService.getBanners({
            CategoryId: this.category.NodeId,
            IsSpecialRoot: false,
        });
    }
}

const categoryHeaderBannersComponentDefinition = {
    bindings: {
        category: '<',
    },
    controller: ['BannersService', categoryHeaderBannersController],
    template: require('./category-header-banners.component.html').trim(),
};

module.exports = {
    categoryHeaderBannersController,
    categoryHeaderBannersComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/category-header-banners.component.js